import { COMMON_MIXPANEL_PAGE } from '../../common/constants/mixpanelConstants'
import { UTM_CAMPAIGN } from '../../common/constants/utm'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const managerCoachingMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MANAGER_COACHING,
  iFrameSrcUrl: '/manager-coaching',
  micrositeUrl: 'manager-coaching',
  title: {
    id: 'managerCoaching.title',
    defaultMessage: 'Support for managers',
    description: 'Microsite page title',
  },
  featureFlag: 'isManagerCoachingEnabled',
  customerPropertyConditions: [],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.OPEN_CONTACT_CARE_NAVIGATOR_MODAL },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_PROVIDER_BOOKING },
  ],
  page: COMMON_MIXPANEL_PAGE.MANAGER_COACHING,
  trackUTMParams: {
    utm_campaign: UTM_CAMPAIGN.MANAGER_COACHING,
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: false,
  usePageForViewEvent: true,
}
